export const ELEMENT_MAX_WIDTH = '31.25rem';
export const FIELD_MAX_HEIGHT = '2.125rem';